export default "__VITE_ASSET__DX6f330a__"